/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qrscanner[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;overflow:hidden}.qrscanner__video.--left[_ngcontent-%COMP%], .qrscanner__video.--right[_ngcontent-%COMP%]{-webkit-transform:translateX(-35vw) rotateY(180deg);transform:translateX(-35vw) rotateY(180deg)}.qrscanner__video.--top[_ngcontent-%COMP%]{-webkit-transform:rotateY(180deg);transform:rotateY(180deg);width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.qrscanner__canvas[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
